import { state, props } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'
import unfocusTag from '../actions/unfocusTag'

export default [
  set(state`selectr.${props`namespace`}.input.value`, props`value`),
  when(props`value`, val => val.length === 1),
  {
    true: [
      set(state`selectr.${props`namespace`}.optionsClosed`, false),
      when(state`selectr.${props`namespace`}.performTagUnfocus`),
      {
        true: [
          set(state`selectr.${props`namespace`}.performTagUnfocus`, false),
          unfocusTag
        ],
        false: []
      }
    ],
    false: [
      when(props`value`, val => val.length === 0),
      {
        true: [set(state`selectr.${props`namespace`}.optionsClosed`, true)],
        false: []
      }
    ]
  },
  set(state`selectr.${props`namespace`}.focusedTag`, null),
  set(state`selectr.${props`namespace`}.focusedOption`, null)
]
